// typings
import { AlertStatusFilter } from 'modules/PriceAlerts/typings';
import { PriceAlertsFilterDropdown } from './typings';

export const DropDownValues: PriceAlertsFilterDropdown = [
  { title: 'All', value: AlertStatusFilter.ALL },
  { title: 'Active', value: AlertStatusFilter.ACTIVE },
  { title: 'Triggered', value: AlertStatusFilter.TRIGGERED },
];
